var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEliminated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 6 6",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7f0000",
    d: "M0 0h2M0 1h3M1 2h3M2 3h3M3 4h3M4 5h2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminated);
export default __webpack_public_path__ + "static/media/eliminated.ab6ef2b87e4ad24918421f3690e461b9.svg";
export { ForwardRef as ReactComponent };